export default {
  width: 25,
  height: 25,
  svg: `
    <path fill-rule="evenodd" d="M2.573 22.427a.781.781 0 0 0 .552.23H12.5v1.562H2.344A1.563 1.563 0 0 1 .78 22.656V4.688a1.562 1.562 0 0 1 1.563-1.563H6.25V.781a.781.781 0 0 1 1.563 0v2.344h9.375V.781a.781.781 0 1 1 1.562 0v2.344h3.906a1.562 1.562 0 0 1 1.563 1.563V12.5h-1.563V7.812a.781.781 0 0 0-.781-.78H3.125a.781.781 0 0 0-.781.78v14.063c0 .207.082.406.229.552Zm13.92-7.443a5.469 5.469 0 1 1 6.076 9.094 5.469 5.469 0 0 1-6.076-9.094Zm3.82 5.329h2.343V18.75h-2.343v-2.344H18.75v2.344h-2.344v1.563h2.344v2.343h1.563v-2.343Z" clip-rule="evenodd"/>
  `
}
